import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "flex flex-col items-center w-full h-full bg-tethys-1 overflow-hidden",
  autocomplete: "off"
}
const _hoisted_2 = { class: "w-full px-4 pt-8 2xl:pt-16 pb-32 bg-white text-center" }
const _hoisted_3 = { class: "w-[85vw] sm:w-[75vw] 2xl:w-[67vw] mx-auto" }
const _hoisted_4 = { class: "text-xl md:text-2xl font-bold text-tethys-blue1-dark mb-4" }
const _hoisted_5 = { class: "text-gray-500 text-sm md:text-base mx-auto mb-10 leading-relaxed" }
const _hoisted_6 = { class: "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-6" }
const _hoisted_7 = { class: "w-16 h-16 mx-auto mb-3 flex items-center justify-center bg-tethys-blue1-light group-hover:bg-blue-200 rounded-full text-tethys-blue1-dark text-xl 3xl:text-2xl group-hover:text-2xl 3xl:group-hover:text-3xl" }
const _hoisted_8 = {
  key: 0,
  target: "_blank",
  href: "https://www.coretrustseal.org/"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "text-sm text-gray-500 transition-all duration-300" }
const _hoisted_11 = { class: "inline group-hover:hidden" }
const _hoisted_12 = { class: "hidden group-hover:inline" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vs_input = _resolveComponent("vs-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_vs_input, {
      placeholder: _ctx.$t('enter_your_search_term'),
      onSearchChange: _ctx.onSearch
    }, null, 8, ["placeholder", "onSearchChange"]),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('home_title')), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('home_subtitle')), 1),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cards, (card, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "group h-[320px] 2xl:h-[350px] bg-gray-50 rounded-xl shadow-sm py-6 px-4 transition-transform duration-300 hover:-translate-y-1 hover:shadow-lg"
            }, [
              _createElementVNode("div", _hoisted_7, [
                (card.key === 'certified')
                  ? (_openBlock(), _createElementBlock("a", _hoisted_8, [
                      _createElementVNode("img", {
                        src: require('@/assets/site/img/CTS_logo_values.png'),
                        alt: "icon",
                        class: "w-15 group-hover:w-11 rounded-full"
                      }, null, 8, _hoisted_9)
                    ]))
                  : (_openBlock(), _createElementBlock("i", {
                      key: 1,
                      class: _normalizeClass(card.icon)
                    }, null, 2))
              ]),
              _createElementVNode("h3", {
                class: _normalizeClass([
                                'font-semibold group-hover:text-tethys-blue1-dark 3xl:group-hover:text-lg mb-1',
                                card.key === 'certified'
                                    ? 'text-black'
                                    : 'text-gray-700'
                            ])
              }, _toDisplayString(_ctx.$t(`cards.${card.key}.title`)), 3),
              _createElementVNode("p", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t(`cards.${card.key}.description_default`)), 1),
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t(`cards.${card.key}.description_hover`)), 1)
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}